var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.47.572h6.614c1.397 0 2.44.344 3.128 1.032.687.687 1.03 1.73 1.03 3.127v4.705H9.13V4.73c0-.784-.162-1.36-.486-1.73-.323-.369-.843-.554-1.56-.554h-4.5v11.216H.47V.573ZM4.8 13.663V4.8h2.113v6.988h4.5c.716 0 1.236-.184 1.56-.554.324-.37.486-.946.486-1.73V.71h2.113v8.795c0 1.398-.343 2.44-1.03 3.128-.688.688-1.731 1.031-3.129 1.031H4.8Z",
    fill: "#2F42C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInvoice);
export default __webpack_public_path__ + "static/media/profile_invoice.cd9979da1961f0c79a290e9259e62960.svg";
export { ForwardRef as ReactComponent };